import useAuth from '@/api/auth';
import { loadLanguageAsync } from '@/i18n-setup';

const { isLoggedIn, loadUser, token, loadProfile } = useAuth();

export async function loggedIn({ to, next, nextMiddleware }) {
  if (!isLoggedIn.value && to.name !== 'login') {
    if (token.value) {
      await loadLanguageAsync();
      await loadUser();
      await loadProfile();
    } else {
      return next('/login');
    }
  }
  return nextMiddleware();
}
